export default __webpack_public_path__ + "static/media/back.e31113cb.png";